<template>
  <div :class="$style.wrapper">
    <div :class="$style.hint">
      <Hint>
        <p style="font-style: italic;">{{text}}</p>
      </Hint>
    </div>
    <img :src="char" :class="$style.char">
  </div>
</template>
<script>
import Hint from '@/components/@ui/Hint/Hint.vue'

export default {
  name: 'HintChar',
  components: { Hint },
  props: {
    char: {
      type: String,
      default: require('./assets/zpt.svg'),
    },
    text: {
      type: String,
      default: 'Присмотрись внимательнее. Пока никто не видит, я подскажу, где находятся нужные устройства.',
    },
  },
}
</script>
<style lang="scss" module>
@import './HintChar.scss';
</style>
